export default "__VITE_ASSET__DMHcZziA__"